import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { FixedExpensesForm } from '@/components/forms/FixedExpensesForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditFixedExpensesPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined

  const handleSuccess = () => {
    navigate('/rates-and-expenses/fixed-expenses')
  }

  const handleCancel = () => {
    navigate('/rates-and-expenses/fixed-expenses')
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit Fixed Expenses
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update Fixed Expense details
            </Text>
          </CardHeader>
          <CardBody>
            <FixedExpensesForm fixedExpensesId={numericId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


